$(document).ready(function () {
  //Стилизируем шапку при скроле
  function fixedHeader() {
    var topp = 1;
    function fixScroll() {
      if (window.scrollY > topp) {
        $(".header").addClass("fixed");
      }
      if (window.scrollY < topp) {
        $(".header").removeClass("fixed");
      }
    }

    fixScroll();

    $(window).scroll(function () {
      fixScroll();
    });
  }
  fixedHeader();

  $(window).resize(function () {
    fixedHeader();
  });

  //Инициализируем стайлер для селектов
  if ($(".js-formstyller-style").length > 0) {
    setTimeout(function () {
      $(".js-formstyller-style").css("visibility", "visible");
    }, 300);
    $(".js-formstyller-style").styler();
  }

  // Скролл к блоку
  $(".js-scroll").click(function (e) {
    e.preventDefault();
    let top = $(this);
    id = top.attr("href");
    $(".header-nav").removeClass("visible");
    $("html, body").animate(
      {
        scrollTop: $(id).offset().top - 75,
      },
      1200
    );
  });

  // Слайдер с результатами клиентов
  $(".clients-result-slider, .our-advantages-slider").on("init", function (event, slick) {
    $(this).css("visibility", "visible");
  });
  if ($(".clients-result-slider, .our-advantages-slider").length > 0) {
    $(".clients-result-slider, .our-advantages-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 700,
      arrows: true,
      dots: false,
      infinite: false,
      swipe: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  // Слайдер с тарифами
  $(".packages-slider").on("init", function (event, slick) {
    $(this).css("visibility", "visible");
  });
  if ($(".packages-slider").length > 0) {
    $(".packages-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      arrows: true,
      dots: false,
      infinite: false,
      centerMode: true,
      swipeToSlide: true,
      centerPadding: "0.87vw",
      initialSlide: 1,
    });
  }

  // Стилизация инпутов при вводе и заполнении
  $(".input-row__input")
    .on("focus", function () {
      $(this).closest(".input-row").addClass("focused");
    })
    .on("blur", function () {
      $(this).closest(".input-row").removeClass("focused");
    })
    .on("input", function () {
      if ($(this).val().trim() !== "") {
        $(this).closest(".input-row").addClass("filled");
      } else {
        $(this).closest(".input-row").removeClass("filled");
      }
    });

  // Check initial values
  $(".input-row__input").each(function () {
    if ($(this).val().trim() !== "") {
      $(this).closest(".input-row").addClass("filled");
    }
  });

  $(".js-country-phone").keypress(function (event) {
    event = event || window.event;
    if (
      event.charCode &&
      event.charCode != 0 &&
      event.charCode != 46 &&
      (event.charCode < 48 || event.charCode > 57)
    )
      return false;
  });

  //Открываем-закрываем меню на мобилке
  $(".js-open-menu").click(function (e) {
    e.preventDefault();
    $(".header-nav").addClass("visible");
  });

  $(".js-close-menu").click(function (e) {
    e.preventDefault();
    $(".header-nav").removeClass("visible");
  });

  //Делаем маску для номера карты и cvv 2 кода
  if ($("#card-number").length > 0) {
    $("#card-number").inputmask("9999 9999 9999 9999");
  }
  if ($("#cvv2").length > 0) {
    $("#cvv2").inputmask("999");
  }

  //Подключаем телефоны всех стран
  if ($(".js-country-phone").length > 0) {
      function getUserCountry(callback) {
          $.get("https://ipapi.co/json/", function(response) {
              var countryCode = (response && response.country_code) ? response.country_code.toLowerCase() : "ua";
              callback(countryCode);
          }).fail(function(jqXHR, textStatus, errorThrown) {
              var defaultCountryCode = "ua";
              callback(defaultCountryCode);
          });
      }

    $(".js-country-phone").intlTelInput({
      // preferredCountries: ["ua"],
      allowDropdown: true,
      // autoHideDialCode: false,
      // autoPlaceholder: "off",
      //dropdownContainer: document.body,
      // excludeCountries: ["us"],
      // formatOnDisplay: false,
        initialCountry: "auto",
      geoIpLookup: function(callback) {
          getUserCountry(callback);
      },
      hiddenInput: "full_number",
      // localizedCountries: { 'de': 'Deutschland' },
      // nationalMode: false,
      // onlyCountries: ['us', 'gb', 'ch', 'ca', 'do'],
      // placeholderNumberType: "MOBILE",
      // preferredCountries: ['cn', 'jp'],
      separateDialCode: true,
      utilsScript: "./utils.js",
    });
  }

  //Проставляем первую букву имени в аватар
  if ($(".cabinet-wrp").length > 0) {
    let currentNameText = $(".js-user-name").text();
    $(".js-first-letter").text(currentNameText[0]);
    $(".js-avatar-bg-color").css("background-color", randColor());
  }

  //Рандомный цвет для аватарок
  function randColor() {
    let rand = () => Math.floor(Math.random() * (255 + 1 - 0) + 0);
    return `rgb(${rand()},${rand()},${rand()})`;
  }

  //Открываем-акрываем меню в кабинете
  $(".js-open-close-cabinet-nav").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(".cabinet-nav-wrp").toggleClass("visible");
  });

  //Показать больше электронных книг
  $(".js-show-more").click(function (e) {
    e.preventDefault();
    $(this).closest(".e-books-content").find("div.hidden").removeClass("hidden");
    $(this).closest(".show-more-row").remove();
  });
});
